import createClient from "openapi-fetch";
import { operations, paths } from "./generated-types";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
});

export const register = (
  body: operations["registration.write.register"]["requestBody"]["content"]["application/json"],
  params: operations["registration.write.register"]["parameters"],
) => {
  return client.POST("/v1/registration.write/register", {
    body,
    params,
    signal: AbortSignal.timeout(4000),
  });
};

export const cancel = (
  body: operations["registration.write.cancel"]["requestBody"]["content"]["application/json"],
  params: operations["registration.write.cancel"]["parameters"],
) => {
  return client.POST("/v1/registration.write/cancel", {
    body,
    params,
    signal: AbortSignal.timeout(4000),
  });
};

export const listAllEvents = (
  params: operations["event.read.getallevents"]["parameters"],
) => {
  return client.GET("/v1/event.read/getAllEvents", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};

export const getRegistrationsByEvent = (eventId: string) => {
  return client.GET("/v1/registration.read/getByEvent", {
    params: { query: { eventId } },
    signal: AbortSignal.timeout(4000),
  });
};

export const getRecentRegistrations = () => {
  return client.GET("/v1/registration.read/recent", {
    signal: AbortSignal.timeout(4000),
  });
};

export const searchRegistrations = (query: string) => {
  return client.GET("/v1/registration.read/search", {
    params: { query: { query } },
    signal: AbortSignal.timeout(4000),
  });
};

export const getStatistics = () => {
  return client.GET("/v1/event.read/statistics", {
    signal: AbortSignal.timeout(2000),
  });
};

export const deleteRegistration = (registrationId: string) => {
  return client.DELETE("/v1/registration.write/{registrationId}", {
    params: { path: { registrationId } },
    signal: AbortSignal.timeout(4000),
  });
};
